<template>
    <div v-if="isModalVisible">

            <div class="col-11 p-0" id="courses-collapse" style="margin: 0 auto;">
                

              <div v-if="courseModules.length > 0" class="coursemodules">

                  <div class="row col-12 float-left account_view_list_heading_row">
                      <div class="row col-12">
                          <div class="col-12 p-0" style="display: flex;">
                              <div class="float-left heading courses_content_1 text-align-left">Module Name</div>
                              <div class="float-left heading courses_content_2 text-align-center">Score</div>
                              <div class="float-left heading courses_content_3 text-align-center">Completion Date</div>
                          </div>
                      </div>
                  </div>



                  <div v-for="(item, mindex) in courseModules" :key="mindex" class="row float-left col-12 p-0 border-class">
                      <div class="row col-12">
                          <div class="row col-12">
                              <div class=" col-12 p-0" style="display: flex;">
                                  <div class="float-left courses_row courses_content_1 text-align-left" style="padding-left: 15px;">{{ formatModuleName(item.module_name, mindex)  }}</div>
                                  <div class="float-left courses_row courses_content_2 text-align-center">
                                      <span v-if="item.score != 'N/A'">{{ item.score }}%</span>
                                      <span v-else>&nbsp;</span>
                                  </div>
                                  <div class="float-left courses_row courses_content_3 text-align-center">
                                      <span v-if="item.module_attended_date != 'N/A'">{{ item.module_attended_date | formatModuleDate }}</span>
                                      <span v-else>&nbsp;</span>
                                  </div>
                              </div>
                          </div>
                          <hr class="courses_hr" v-if="mindex == courseModules.length">
                      </div>
                  </div>
              </div>

            </div>
            <div style="clear: both;"></div>

    </div>
</template>
<script>
import axios from 'axios';
export default {
    props: [
        'courseModules',
        ],
    data() {
        return{
            isModalVisible: false,
        }
    },
    methods: {
          formatModuleName(name, num) {
            return (num +1) + '. ' + name;
          },
        fetchRepsHistory() {
            if (!this.isModalVisible) {
                this.isModalVisible = true;
                this.$parent.toggleFontIcon = 'fa fa-angle-up';
            } else {
                this.hideRepsHistory();
            }
        },
        hideRepsHistory() {
            this.isModalVisible = false;
            this.$parent.toggleFontIcon = 'fa fa-angle-down';
        },
    }
}
</script>
<style scoped>
.reps_card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
.edit-rep {
    font-size: 13px;
    text-decoration: none;
    margin-left: 15px;
}
.delete-rep {
    color: #FF0000;
    font-size: 13px;
    text-decoration: none;
}
.account_view_list_heading_row {
    background-color: #29A3E4;
    padding: 3px 10px;
}
.account_view_list_row { 
    width: 100%;
    padding: 5px 10px;
}
.heading {
    color: #FFF;
    font-size: 14px;
}

.courses_content_1 {
  width: 50%;
  float: left;
}
.courses_content_2, .courses_content_3 {
  width: 25%;
  float: left;
}
.courses_row {
  color: #002F42;
  font-size: 13px;
  font-weight: bold;
  padding-bottom: 5px;
}
.coursemodules .border-class:not(:last-child) {
  border-bottom: 1px solid #CCC;
  margin-bottom: 5px;    
}
</style>


// WEBPACK FOOTER //
// src/components/manager/course_module_details.vue